module.exports = __webpack_public_path__ + "img/4.350e84a3.png";